module.exports = "data:image/png;base64,R0lGODlhAQABAIABAFSppgAAACH+EUNyZWF0ZWQgd2l0aCBHSU1QACwAAAAAAQABAAACAkQBADs="